import styled from "styled-components";

export const AppHolder = styled.div`
  height: 100%;
`;
